import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { canChangeSiteAvailability } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { Messages } from '../../codegen/Localize';
import { SiteAvailabilityState } from '../../commonInfra/utils/sites/SitePropertyTypes';
import { ISiteSettingsForServerAdmin } from '../../settings/types/ISite';
import { suspendSite } from '../actions/SiteMenuActions';

export const SuspendSiteAction: IEntityAction<ISiteSettingsForServerAdmin, {}> = {
  name: EntityActionNames.SuspendSite,
  translateName: Messages.suspend_action,
  isVisible: (targetItems: ISiteSettingsForServerAdmin[]) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: ISiteSettingsForServerAdmin[]) => {
    return canChangeSiteAvailability(targetItems, SiteAvailabilityState.SUSPENDED);
  },
  createReduxAction: (targetItems: ISiteSettingsForServerAdmin[]) => suspendSite(targetItems)
};
